import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetIcb from '../../../../common/category/useGetIcb'
import useGetVsic from '../../../../common/category/useGetVsic'
import { Element } from '../../../../common/html/element'
import { Tabs } from '../../../../common/tabs'
import classes from '../../../index.module.scss'
import {
  selectIcbChecked,
  selectVsicChecked,
  selectVsicOrIcbTab,
  setVsicOrIcbTab,
} from '../../store/slice'
import { TABS_KEY, getAppendStyleItem, getTabs } from '../constants'
import SelectedItem from './SelectedItem'

export const InterestedIndustries = () => {
  const { vsics } = useGetVsic()
  const { icbs } = useGetIcb()

  const dispatch = useDispatch()

  const icbChecked = useSelector(selectIcbChecked)
  const vsicChecked = useSelector(selectVsicChecked)
  const tab = useSelector(selectVsicOrIcbTab)

  const tabs = getTabs(vsics, icbs)

  const changeTab = (key) => {
    dispatch(setVsicOrIcbTab(key))
  }

  useEffect(() => {
    if (icbChecked.length) {
      dispatch(setVsicOrIcbTab(TABS_KEY.ICB))
    }
  }, [icbChecked])

  useEffect(() => {
    if (vsicChecked.length) {
      dispatch(setVsicOrIcbTab(TABS_KEY.VSIC))
    }
  }, [vsicChecked])

  return (
    <div className={classes.settingsContent} style={{ height: 300 }}>
      <Element
        className={classes.preferencesHeader}
        style={{ backgroundColor: '#F3F3F3' }}
      >
        <Element
          className="fw600"
          style={{ fontSize: 14, padding: '8px 0 8px 10px' }}
        >
          <Translate value="settingPreferences.INTERESTED_INDUSTRIES" />
        </Element>
      </Element>
      <div className={[classes.interestedContainer, 'flexColumn'].join(' ')}>
        <div className={[classes.content, 'flex1'].join(' ')}>
          <div className="w50 h100">
            <Tabs
              items={tabs}
              tabListClassName={classes.tabs}
              getAppendStyleItem={getAppendStyleItem}
              isScrollContent={false}
              onChange={changeTab}
              activeKey={tab}
            />
          </div>
          <div className="w50 h100">
            <SelectedItem
              isVsic={!!vsicChecked?.length}
              vsics={vsics}
              icbs={icbs}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
